import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/toso-logo.svg")